module.exports = __webpack_public_path__ + "img/About_two.50161ecb.png";